"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fileSaver = require("file-saver");
var _axios = _interopRequireDefault(require("axios"));
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var baseURL = process.env.VUE_APP_BASE_API;
function buildDownloadUrl(downloadUrl) {
  if (/^https?:\/\//i.test(downloadUrl)) {
    return downloadUrl;
  }
  var configuredUrl = baseURL || window.location.origin;
  var fileServerUrl = window.location.origin;
  var urlParser = document.createElement('a');
  urlParser.href = configuredUrl;
  if (urlParser.protocol && urlParser.host) {
    fileServerUrl = "".concat(urlParser.protocol, "//").concat(urlParser.host);
  }
  return "".concat(String(fileServerUrl).replace(/\/+$/, ''), "/").concat(String(downloadUrl).replace(/^\/+/, ''));
}
var _default = exports.default = {
  name: function name(_name) {
    var _this = this;
    var isDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var url = baseURL + '/common/download?fileName=' + encodeURI(_name) + '&delete=' + isDelete;
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + (0, _auth.getToken)()
      }
    }).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
        var isLogin, blob;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.blobValidate(res.data);
            case 1:
              isLogin = _context.v;
              if (isLogin) {
                blob = new Blob([res.data]);
                _this.saveAs(blob, decodeURI(res.headers['download-filename']));
              } else {
                _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  resource: function resource(_resource) {
    var _this2 = this;
    var url = baseURL + '/common/download/resource?resource=' + encodeURI(_resource);
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + (0, _auth.getToken)()
      }
    }).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
        var isLogin, blob;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.blobValidate(res.data);
            case 1:
              isLogin = _context2.v;
              if (isLogin) {
                blob = new Blob([res.data]);
                _this2.saveAs(blob, decodeURI(res.headers['download-filename']));
              } else {
                _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  zip: function zip(url, name) {
    var _this3 = this;
    var url = baseURL + url;
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + (0, _auth.getToken)()
      }
    }).then(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
        var isLogin, blob;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.blobValidate(res.data);
            case 1:
              isLogin = _context3.v;
              if (isLogin) {
                blob = new Blob([res.data], {
                  type: 'application/zip'
                });
                _this3.saveAs(blob, name);
              } else {
                _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  url: function url(downloadUrl, fileName) {
    if (!downloadUrl) {
      _elementUi.Message.error('文件下载地址不存在');
      return;
    }
    var link = document.createElement('a');
    link.href = buildDownloadUrl(downloadUrl);
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    if (fileName) {
      link.download = fileName;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  saveAs: function saveAs(text, name, opts) {
    (0, _fileSaver.saveAs)(text, name, opts);
  },
  blobValidate: function () {
    var _blobValidate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
      var text, _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return data.text();
          case 1:
            text = _context4.v;
            JSON.parse(text);
            return _context4.a(2, false);
          case 2:
            _context4.p = 2;
            _t = _context4.v;
            return _context4.a(2, true);
        }
      }, _callee4, null, [[0, 2]]);
    }));
    function blobValidate(_x4) {
      return _blobValidate.apply(this, arguments);
    }
    return blobValidate;
  }()
};